import Swiper, { Pagination } from "swiper";

const FontFaceObserver = require("fontfaceobserver");

export default {
  init() {
    const _self = this;

    if (window.outerWidth <= 767) {
      return false;
    }

    const sliders = [];

    Swiper.use([Pagination]);

    const font = new FontFaceObserver("Raleway", {
      weight: 400,
    });

    font.load().then(() => {
      setTimeout(() => {
        _self.initializeSliders();
      }, 200);
    }, () => {
      // alert('Font is not available');
    });
  },
  initializeSliders() {
    const _self = this;

		console.log('initializeSliders');

    document.querySelectorAll(".vertical-swiper").forEach((verticalSwiperEl, idx) => {
      const verticalSwiper = new Swiper(verticalSwiperEl, {
        direction: "vertical",
        autoHeight: true,
        pagination: {
          el: verticalSwiperEl.querySelector(".swiper-pagination"),
          clickable: true,
        },
        on: {
          init: (swiper) => { this.changeHeight(verticalSwiperEl, swiper.slides[swiper.activeIndex]); },
          slideChangeTransitionEnd: (swiper) => { this.changeHeight(verticalSwiperEl, swiper.slides[swiper.activeIndex]); },
          resize: (swiper) => { this.changeHeight(verticalSwiperEl, swiper.slides[swiper.activeIndex]); },
        },
      });
    });
  },
  /**
	 * @param {HTMLElement} swiper swiper to change the height of
	 * @param {HTMLElement} slide slide to get the height from.
	 */
  changeHeight(swiper, slide) {
    const grid = slide.querySelector(".grid");
    const image = slide.querySelector("img, video");
    if (grid) {
			console.log("changeHeight exists");
			if (image.complete) {
        const height = grid.offsetHeight;
        swiper.style.height = `${height}px`;
        console.log(`Image already loaded with height ${height}`);
      } else {
        image.addEventListener("load", () => {
          const height = grid.offsetHeight;
          swiper.style.height = `${height}px`;
          console.log(`Image loading completed, setting height to ${height}`);
        });
      }
    }
  },
};
